import { EventType, useGetMeEventUsersEventInfoForMePageQuery } from '@graphql/generated';

export const useMeEventUsersEventInfoforMePage = () => {
  const { data, loading } = useGetMeEventUsersEventInfoForMePageQuery({
    batchMode: 'off',
    variables: { filterEventTypes: [EventType.wedding, EventType.babyRegistry, EventType.general] },
  });

  return { data, loading };
};
